import React from 'react';
import { ArrowUp, ArrowDown, Minus } from 'lucide-react';
interface StatCardProps {
  title: string;
  value: string | number;
  change?: number;
  icon: React.ReactNode;
  iconBg: string;
  description?: string;
}
const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  change,
  icon,
  iconBg,
  description
}) => {
  const renderChangeIndicator = () => {
    if (change === undefined) return null;
    if (change > 0) {
      return <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200" data-id="element-51">
          <ArrowUp size={12} className="mr-1" data-id="element-52" />
          {change}%
        </span>;
    } else if (change < 0) {
      return <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200" data-id="element-53">
          <ArrowDown size={12} className="mr-1" data-id="element-54" />
          {Math.abs(change)}%
        </span>;
    } else {
      return <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200" data-id="element-55">
          <Minus size={12} className="mr-1" data-id="element-56" />
          {change}%
        </span>;
    }
  };
  return <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6 hover:shadow-md transition-shadow" data-id="element-57">
      <div className="flex items-center" data-id="element-58">
        <div className={`flex items-center justify-center h-12 w-12 rounded-md ${iconBg} text-white`} data-id="element-59">
          {icon}
        </div>
        <div className="ml-5" data-id="element-60">
          <p className="text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-61">
            {title}
          </p>
          <div className="flex items-baseline" data-id="element-62">
            <p className="text-2xl font-semibold text-gray-900 dark:text-white" data-id="element-63">
              {value}
            </p>
            {change !== undefined && <span className="ml-2" data-id="element-64">{renderChangeIndicator()}</span>}
          </div>
        </div>
      </div>
      {description && <p className="mt-2 text-sm text-gray-500 dark:text-gray-400" data-id="element-65">
          {description}
        </p>}
    </div>;
};
export default StatCard;